import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Typography, Button, Row, Col, Breadcrumb } from "antd";
import PatientMedicineTakenTable from "../../../components/Tables/PatientMedicineTakenTable";
import { translate } from "../../../locale";

const { Text } = Typography;

const PatientMedicine = () => {
  const navigate = useNavigate();
  const { username } = useParams();

  return (
    <div className="flex flex-col items-start min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row gutter={16} className="mb-8 w-full">
        <Col className="gutter-row" span="12">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/admin/buscar-paciente/${username}/medicinas-paciente`}
              >
                {translate("Medicamentos del Paciente")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Tomas")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>

      <div className="flex flex-col justify-center w-full">
        <PatientMedicineTakenTable />
      </div>
    </div>
  );
};

export default PatientMedicine;
